import { FunctionComponent } from 'react'
import { CardContentGrid, CollapsibleCard } from '@black-bear-energy/rucksack'
import { CardContentField } from './CardContentField'
import { SiteRFPDetails } from '@black-bear-energy/black-bear-energy-common'
import { formatAsCurrency } from 'components/helpers/formatAsCurrency'

export const ProjectDetailsCard: FunctionComponent<ProjectDetailsCardProps> = ({
  siteRFPDetails,
  isFetching,
}) => {
  const formattedArrayArea =
    siteRFPDetails?.arrayArea != null
      ? `${Math.round(siteRFPDetails.arrayArea).toLocaleString('en')} ft²`
      : null
  const formattedAnnualProduction =
    siteRFPDetails?.annualProduction != null
      ? `${Math.round(siteRFPDetails.annualProduction).toLocaleString(
          'en'
        )} kWh`
      : null
  const formattedITC =
    siteRFPDetails?.itc != null ? `${Math.round(siteRFPDetails.itc)}%` : null
  const formattedYield =
    siteRFPDetails?.yield != null
      ? `${Math.round(siteRFPDetails.yield)} kWh/kW`
      : null
  const formattedIXCost =
    siteRFPDetails?.ixCost != null
      ? `${formatAsCurrency(siteRFPDetails.ixCost)}/Wdc`
      : null

  return (
    <CollapsibleCard title="Project Details">
      <CardContentGrid columns={4}>
        <CardContentField
          label="Energy Technology"
          value={siteRFPDetails?.energyTechnology}
          isFetching={isFetching}
        />
        <CardContentField
          label="Array Area"
          value={formattedArrayArea}
          isFetching={isFetching}
        />
        <CardContentField
          label="Year 1 Production"
          value={formattedAnnualProduction}
          isFetching={isFetching}
        />
        <CardContentField
          label="Awarded Channel Partner"
          value={siteRFPDetails?.channelPartnerName}
          isFetching={isFetching}
        />
        <CardContentField
          label="ITC"
          value={formattedITC}
          isFetching={isFetching}
        />
        <CardContentField
          label="Yield"
          value={formattedYield}
          isFetching={isFetching}
        />
        <CardContentField
          label="IX Cost"
          value={formattedIXCost}
          isFetching={isFetching}
        />
      </CardContentGrid>
    </CollapsibleCard>
  )
}

export interface ProjectDetailsCardProps {
  siteRFPDetails?: SiteRFPDetails | null
  isFetching: boolean
}
